import { Button } from "antd"
import {meetService} from "../../services/meetService";
import { useDispatch } from "react-redux";
import { meetActions } from "../../store/slices/meet_slice/meetslice";
import {videoCallService} from "../../base/service/videoCallService";
import store from "../../store/redux-store/root_store";
import { useEffect, useState } from "react";
import { MeetGuest, MeetServices } from "../../base/service/apiServices";
import styles from "./rightcontainer.module.scss";
import { useLocation } from "react-router";
import { LoginActions } from "../../store/slices/authentication_slice/login_slice";
import { getUserInfo, throwLoading, updateJoinArrowKey } from "../../base/video_common";
import { meetActionTypes } from "../../base/action/action";
import { getToken } from "../../base/utils";
import { GetItemFromStorage, SetItemInStorage } from "../../custom_hooks/useStorage";
import { LocalStorage } from "../../custom_hooks/localStorageKeys";
import _ from "lodash";

type ParticipantTypeProps = {
  participantType: string;
}
type RightContainerState = {
  firstname: string;
  tokens: string;
  modalOpen: boolean;
  isGuestToken: boolean;
  nameValid: boolean;
  modalCompletedOpen: boolean;
}
const RightContainer = ({ participantType }: ParticipantTypeProps) => {
  let dispatch = useDispatch();
  let location = useLocation();
  const getCookie: any = getToken();
  const tokens=getCookie["guestToken"];
   const userDetials = GetItemFromStorage(LocalStorage.USER_DETAILS);
    const LoginUserDetails: any = userDetials;
  let { meetingDetails,arrowKey }: any = store.getState().meetingReducer;
  let parsed:any= LoginUserDetails;
  const [meetingInput, setmeetingInput] = useState<RightContainerState>({
    firstname: "", tokens: "", modalOpen: false, isGuestToken: false, nameValid: false, modalCompletedOpen: false
  });
  const createGuest = (name: string, meetingid: string, pwd: string) => {
    // let { meetingTitleStatus } = store.getState().meetingReducer;
    let errMsg: string = "Something went wrong!!!";
    return new Promise((resolve, reject) => {
      MeetGuest.post({ name, meetingid, pwd: decodeURIComponent(pwd) }, "create_guest").then(async (data: any) => {
        if (data.data.statusCode === 200) {

          document.cookie = "guestToken=" + data.data.message + "; path=/; domain=";
          SetItemInStorage("guest", data.data.user_details);
          SetItemInStorage("ACCESS_TOKEN", data.data.message);
          SetItemInStorage('isLoggedIn', "1");
          SetItemInStorage("authorization", data.data.message);
          getUserInfo(data.data.message,dispatch,data.data.user_details, "guest");
          await MeetServices.get(meetingid, "get_agent_meeting").then((data2: any) => {

            if (data2?.data.data) {

              store.dispatch({
                type: meetActionTypes.UPDATE_MEET_DETAILS,
                payload: {
                  meetingDetails: data2?.data.data.meetingDetails
                }
              });
              // dispatch(meetActions.updateMeetDetails({meetingDetails:data2?.data.result}))

              new videoCallService(dispatch).createConnection(data2?.data.data.meetingDetails.uuid, "");
              SetItemInStorage('createConnection', "1");

            }
            resolve(data.data.message);
          });
        } else if (data.data.statusCode === 424) {
          errMsg = data.data.message;
          new meetService(dispatch).throwError(errMsg);
            throwLoading(false);
          reject(false);
        }
      }).catch((err: any) => {
        new meetService(dispatch).throwError(err);
        throwLoading(false);
      });;
    })
  };

  useEffect(()=>{
    if(meetingInput.firstname.trim() ==="" && !_.isEmpty(LoginUserDetails)){setmeetingInput({...meetingInput,firstname:LoginUserDetails.username})}
  },[userDetials && JSON.stringify(userDetials)])

  var reWhiteSpace = new RegExp("/^\s+$/");
  const handleInputChange = (name: string, e: React.FormEvent<HTMLInputElement>) => {
    let fname = e.currentTarget.value;
    let rE = /[~@^{#%'*/<()>}\:`;,!&.?$\][+=|"]/g;
    if (name === "firstname") {
      if ((!(rE.test(fname))) && (!reWhiteSpace.test(fname))) {
        fname.trim();
        setmeetingInput({ ...meetingInput, [name]: fname, nameValid: false });
      }
    }
    else { setmeetingInput({ ...meetingInput, [name]: e.currentTarget.value, nameValid: false }); }
  };

  const joinWithPassword = async () => {
    const meeting = location?.pathname.slice(1);
    let idx: any = meeting?.lastIndexOf("/");
    const meeting_id = meeting?.slice(idx + 1);
    updateJoinArrowKey(true);
    if (meeting_id && meetingInput.firstname && meetingInput.firstname.trim().length > 0 && !tokens) {
      dispatch(meetActions.updateSocketLoading({ isLoading: true }));
      localStorage.removeItem('deviceid');
      Promise.all([createGuest(meetingInput.firstname, meeting_id, '')]).then((values: any) => {
        updateJoinArrowKey(false);
      }).catch(() => {
        dispatch(meetActions.updateSocketLoading({ isLoading: false }));
      });
    }
    else if(meeting_id && meetingInput.firstname && meetingInput.firstname.trim().length > 0 && tokens){
      throwLoading(true);
      getUserInfo(tokens,dispatch,parsed, "guest");
      await MeetServices.get(meeting_id, "get_agent_meeting").then((data2: any) => {

        if (data2?.data.data) {

          store.dispatch({
            type: meetActionTypes.UPDATE_MEET_DETAILS,
            payload: {
              meetingDetails: data2?.data.data.meetingDetails
            }
          });
          new videoCallService(dispatch).createConnection(meeting_id,false, "");
          SetItemInStorage('createConnection', "1");
          SetItemInStorage('isLoggedIn', "1");

        }
      });
    }
    else if (meeting_id && meetingInput.firstname.trim() === "") {
        updateJoinArrowKey(false);
      dispatch(meetActions.updateSocketLoading({ isLoading: false }));
    }
  };
  return (<>
    <div className={styles.rightsidearea}>
      <h3>Connect with agent</h3>
      <label>Your name</label>
      <input
        value={meetingInput.firstname}
        onChange={(e: React.FormEvent<HTMLInputElement>) => handleInputChange('firstname', e)}
        type="text" className={styles.displayName} placeholder=" " maxLength={25} />
      <Button className={(arrowKey || meetingInput.firstname.trim() === "") ? `${styles.joinnow} ${styles.disabledjoin}` : styles.joinnow} onClick={() => joinWithPassword()}>
        <span>{"Connect"}</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="14" viewBox="0 0 19 14" fill="none">
          <path d="M17.3492 5.40967L13.0787 1.13967C12.7857 0.846672 12.3111 0.846672 12.0182 1.13967C11.7253 1.43267 11.7252 1.90727 12.0182 2.20017L16.0685 6.24997H1.73877C1.32467 6.24997 0.98877 6.58587 0.98877 6.99997C0.98877 7.41407 1.32467 7.74997 1.73877 7.74997H16.0679L12.0181 11.7998C11.7251 12.0928 11.7251 12.5674 12.0181 12.8603C12.1646 13.0068 12.356 13.08 12.5484 13.08C12.7408 13.08 12.9322 13.0068 13.0787 12.8603L17.3443 8.59467C17.772 8.17477 18.0084 7.61327 18.0113 7.01357C18.0142 6.40857 17.7789 5.83937 17.3492 5.40967Z" fill="#e6e4eb" />
        </svg>
      </Button>


    </div>
  </>)
}
export {
  RightContainer
};